import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export function CertificatePreviewDialog({ clientId, name, open, onClose, onSent }) {
  const [certs, setCerts] = useState([]);
  const [active, setActive] = useState(null);
  const [url, setUrl] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get(`/clients/${clientId}/certificates`).then((r) => { setCerts(r.data); setActive(r.data[0] || null); }).catch(() => setCerts([]));
  }, [open, clientId]);
  useEffect(() => {
    if (!active) { setUrl(null); return undefined; }
    let u;
    api.get(`/certificates/${active.cert_id}/pdf`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })); setUrl(u); }).catch(() => setUrl(null));
    return () => u && URL.revokeObjectURL(u);
  }, [active]);

  const send = async () => {
    setSending(true);
    try {
      const r = await api.post(`/clients/${clientId}/certificates/send`);
      toast.success(`Zertifikate an ${r.data.to} gesendet`);
      onSent?.(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl" data-testid="cert-preview-dialog">
        <DialogHeader><DialogTitle>Zertifikat-Vorschau{name ? ` – ${name}` : ""}</DialogTitle></DialogHeader>
        {certs.length > 1 && (
          <div className="flex flex-wrap gap-2">
            {certs.map((c) => (
              <button key={c.cert_id} onClick={() => setActive(c)} className={`text-xs px-3 py-1.5 border transition-colors ${active?.cert_id === c.cert_id ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 hover:border-slate-900"}`} data-testid={`cert-preview-tab-${c.cert_id}`}>{c.module}</button>
            ))}
          </div>
        )}
        <div className="h-[65vh] bg-slate-100 border border-slate-200">
          {url ? <iframe title="Zertifikat" src={url} className="w-full h-full" data-testid="cert-preview-frame" /> : <div className="h-full flex items-center justify-center text-sm text-slate-500"><Loader2 size={16} className="animate-spin mr-2" /> Lädt …</div>}
        </div>
        <div className="flex items-center justify-between gap-3">
          <span className="text-xs text-slate-500">{certs.length} Zertifikat{certs.length === 1 ? "" : "e"}{certs[0]?.emailed_at ? ` · zuletzt gesendet ${new Date(certs[0].emailed_at).toLocaleDateString("de-DE")}` : " · noch nicht gesendet"}</span>
          <div className="flex gap-2">
            <button onClick={onClose} className="px-4 py-2 text-xs border border-slate-300 hover:bg-slate-100" data-testid="cert-preview-close">Schließen</button>
            <button onClick={send} disabled={sending || !certs.length} className="px-4 py-2 text-xs bg-slate-900 text-white hover:bg-black disabled:opacity-50 inline-flex items-center gap-1.5" data-testid="cert-preview-send">
              {sending ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} />} Alles ok – per E-Mail senden
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
